export default "__VITE_ASSET__CcOk_h3h__"